document.addEventListener('DOMContentLoaded', function () {
  const scrollArea = document.querySelector(
    '.comparison-table__content.h-scrollable'
  );

  if (!scrollArea) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  scrollArea.addEventListener('mousedown', (e) => {
    isDown = true;
    scrollArea.classList.add('is-dragging');
    startX = e.pageX - scrollArea.offsetLeft;
    scrollLeft = scrollArea.scrollLeft;
  });

  scrollArea.addEventListener('mouseleave', () => {
    isDown = false;
    scrollArea.classList.remove('is-dragging');
  });

  scrollArea.addEventListener('mouseup', () => {
    isDown = false;
    scrollArea.classList.remove('is-dragging');
  });

  scrollArea.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollArea.offsetLeft;
    const walk = (x - startX) * 1.2; // 드래그 감도
    scrollArea.scrollLeft = scrollLeft - walk;
  });
});


// search background
document.addEventListener('DOMContentLoaded', function() {
  const overlay = document.createElement('div');
  overlay.id = 'search-overlay';
  overlay.style.cssText = 'display:none;position:fixed;inset:0;background:#00000080;z-index:30;cursor:pointer;';
  document.body.appendChild(overlay);

  const observer = new MutationObserver(function() {
    const isOpen = document.querySelector('.template-search__search .search__form.predictive-search-open');

    if (isOpen) {
      overlay.style.display = 'block';
      document.body.classList.add('no-scroll');
      document.body.classList.add('search-active'); 
    } else {
      overlay.style.display = 'none';
      document.body.classList.remove('no-scroll');
      document.body.classList.remove('search-active'); 
    }
  });

  const form = document.querySelector('.template-search__search .search__form');
  if (form) {
    observer.observe(form, { attributes: true, attributeFilter: ['class'] });
  }

  overlay.addEventListener('click', function() {
    const input = document.querySelector('.template-search__search .search__input');
    if (input) input.blur();
  });
});